import React, { useState, useEffect, Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronUpDownIcon } from '@heroicons/react/20/solid';

const pageSizeOptions = [
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 75, label: '75' },
  { value: 100, label: '100' },
];

const ListBoxPageSize = ({ value, onChange }) => {
  const [selected, setSelected] = useState(pageSizeOptions.find(option => option.value === value));

  useEffect(() => {
    setSelected(pageSizeOptions.find(option => option.value === value));
  }, [value]);

  const handleChange = (option) => {
    setSelected(option);
    onChange(option.value);
  };

  return (
    <div className="flex items-center space-x-2">
        <div className="text-sm font-normal text-gray-900 w-40">
            Risultati per pagina
        </div>
        <div className="relative z-100">
            <Listbox value={selected} onChange={handleChange}>
                <div className="relative mt-1">
                    <Listbox.Button className="relative cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                    <span className="block truncate">{selected ? selected.label : 'Seleziona'}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
                    </span>
                    </Listbox.Button>
                    <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <Listbox.Options className="absolute mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
                    >
                        {pageSizeOptions.map((option, index) => (
                        <Listbox.Option
                            key={index}
                            className={({ active, selected }) =>
                            `relative cursor-default select-none py-2 pl-2 pr-4 ${
                                active ? 'bg-indigo-100 text-indigo-900' : 'text-gray-900'
                            }`
                            }
                            value={option}
                        >
                            <div className="flex items-center">
                            <span className="ml-3">{option.label}</span>
                            </div>
                        </Listbox.Option>
                        ))}
                    </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    </div>
  );
  
};

export default ListBoxPageSize;
